export default function EnvelopeSolidIcon({ className }: any) {
  return (
    <svg className={className} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="3.66699" y="5.5" width="14.6667" height="11" rx="2" stroke="currentColor" strokeWidth="1.5" />
      <path
        d="M3.66699 8.25L10.1059 11.4695C10.669 11.751 11.3317 11.751 11.8948 11.4695L18.3337 8.25"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  );
}
